import { render, staticRenderFns } from "./smsSetting.vue?vue&type=template&id=8b731aa4&scoped=true"
import script from "./smsSetting.vue?vue&type=script&lang=js"
export * from "./smsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b731aa4",
  null
  
)

export default component.exports